var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentType === _vm.AppLinkView.a)?_c('a',_vm._b({staticClass:"app-link app-link--a"},'a',_vm.componentAttrs,false),[_vm._t("default")],2):_c('router-link',_vm._b({staticClass:"app-link app-link--router-link",nativeOn:{"click":function($event){return _vm.onClickLink($event)}}},'router-link',_vm.componentAttrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/modules/shared/ui/AppLink.vue?vue&type=template&id=6671256c&
// module id = 1755
// module chunks = 0